import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const passwordSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    forgotPassword: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/users/forgot-password`,
        method: 'POST',
        body,
      }),
    }),

    validateCode: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/users/validate-code`,
        method: 'POST',
        body,
      }),
    }),

    resetPassword: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/users/reset-password`,
        method: 'POST',
        body,
      }),
    }),

    secureAccount: build.mutation<
      {
        message: string
        email: string
        maskedEmail: string
        actions: string[]
        resetCodeSent: boolean
      },
      { token: string }
    >({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/secure-account`,
        method: 'POST',
        body,
      }),
    }),

    confirmLogin: build.mutation<
      {
        message: string
        confirmed: boolean
      },
      { token: string }
    >({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/login-confirm`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useForgotPasswordMutation,
  useValidateCodeMutation,
  useResetPasswordMutation,
  useSecureAccountMutation,
  useConfirmLoginMutation,
} = passwordSlice
